import { asRem } from 'utils';
import styled from 'styled-components';
import { mediaQueries } from 'utils/Constants/Breakpoints';

export default styled.div.attrs({
  className: 'slider-testimonials',
})`
  padding: 0 !important;
  margin: 0 !important;

  .container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    max-width: none !important;
    width: 100% !important;
  }

  .mime-elements-headline-2 {
    margin-bottom: ${asRem(10)};

    ${mediaQueries.md} {
      margin-bottom: ${asRem(30)};
    }
  }

  .mime-elements-paragraph {
    margin: 0;
  }

  .slick-list {
    padding-left: ${asRem(24)} !important;
    padding-right: 0 !important;
    margin: 0;
  }

  .slick-slide {
    padding: 0 ${asRem(8)};
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }

  .quote-box {
    display: flex;
    flex-direction: column;
    height: ${asRem(330)};
    width: ${asRem(290)};
    padding: ${asRem(20)} !important;

    ${mediaQueries.lg} {
      height: ${asRem(360)};
    }
  }

  .quote-box .small {
    flex: 1;
    overflow: auto;
  }

  .quote-img {
    flex-shrink: 0;
    margin-bottom: ${asRem(10)};
  }

  .stars-img {
    margin: 0 0 ${asRem(5)} -${asRem(5)};
  }
`;
